import { supabase } from '@/integrations/supabase/client';

type AnalyticsEvent =
  | 'bet_placed'
  | 'bracket_filled'
  | 'group_created'
  | 'group_joined'
  | 'side_bet_placed'
  | 'leaderboard_viewed'
  | 'bracket_shared'
  | 'tip_jar_clicked';

export async function trackEvent(
  eventName: AnalyticsEvent,
  options?: { groupId?: string; metadata?: Record<string, unknown> }
) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    await supabase.from('analytics_events').insert({
      event_type: eventName,
      user_id: user.id,
      group_id: options?.groupId ?? null,
      metadata: options?.metadata ?? {},
    });
  } catch {
    // Fire-and-forget — never block UI for analytics
  }
}
